import { map } from "rxjs";
import { ServerResult } from "./models/server-result.model";

export const verifyServerResult = <T>() =>
    map((source: ServerResult<T>) => {
        if (source.status === 1) {
            return new ServerResult<T>(source as any);
        }

        throw new ServerResult<T>(source);
    });

export const getData = <T>() => map((source: ServerResult<T>) => source.data);